export default __webpack_public_path__ + "static/media/midnight-series.ddb6ce42.webp";